import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

const Loader = ({ children }) => {
  const loaderReducer = useSelector(
    (state: RootStateOrAny) => state.LoaderReducer,
  );
  const displayLoading = !Object.values(loaderReducer).every(item => !item);
  return (
    <div>
      {displayLoading && (
        <div
          style={{
            position: 'fixed',
            width: '100%',
            height: '100%',
            zIndex: 9999,
            top: 0,
            backgroundColor: 'rgba(0,0,0,.5)',
          }}
        >
          <CircularProgress
            style={{ position: 'relative', top: '50%', left: '50%' }}
          />
        </div>
      )}
      {children}
    </div>
  );
};
export default Loader;
